import { fixStoreReview } from 'entities/user.app-review/model/app-store-review';
import { useMutationCallback } from 'shared/api/hooks';
import { useCallback } from 'react';
import { useAction } from 'shared/hooks/redux/hooks';
import { reviewApp } from 'console/redux/review-reducer';
export function useStartStoreReview() {
    const [run, , response, error] = useMutationCallback('send_status_review_app');
    const reviewAppSlice = useAction(reviewApp);
    const start = useCallback(async () => {
        try {
            await new Promise((resolve, reject) => fixStoreReview((suc) => {
                console.log('appStoreReview success', suc);
                resolve();
            }, (er) => {
                console.log('appStoreReview error', er);
                reject();
            }))
                .then(async (success) => {
                run({
                    data: new Date(),
                });
                console.log('appStoreReview success', success);
                if (response?.ok) {
                    reviewAppSlice(true);
                }
                else if (error) {
                    reviewAppSlice(false);
                }
            })
                .catch((error) => {
                console.log('appStoreReview error', error);
            });
        }
        catch (e) {
            console.error('FAILED appStoreReview', e);
        }
    }, []);
    return start;
}
